import React from "react";
import { FrameView } from "components/FrameView/FrameView";

export const BuisnesMap = () => {
  return (
    <FrameView
      title="Business Map"
      src="https://app.powerbi.com/view?r=eyJrIjoiMzNkM2M1NzctMjQ4Ni00YmZiLWFhNzYtZTg0ZDNkNTQ0MWFjIiwidCI6ImZkYTc1ZGJiLTc5MjUtNGM5Ny1hM2NhLTNiZDJmZDU0OWU5MCIsImMiOjl9"
    />
  );
};
